export const SET_INTERVAL_UPDATE = "SET_INTERVAL_UPDATE";
export const SET_INTERVAL_UPDATE_MINUTES = "SET_INTERVAL_UPDATE_MINUTES";
export const GET_DATA_METRICS = "GET_DATA_METRICS";
export const GET_DATA_METRICS_EXITO = "GET_DATA_METRICS_EXITO";
export const GET_DATA_METRICS_ERROR = "GET_DATA_METRICS_ERROR";
